<script setup lang="ts">
import { Input } from '~ds/components/ui/input';
import { Heading } from '~ds/components/ui/typography';
import { useI18n } from 'vue-i18n';

import type { FeedbackSurveyQuestionText } from './types';

import { feedbackQuestionLabel } from './types';

const props = defineProps<{
  question: FeedbackSurveyQuestionText;
}>();

const model = defineModel<string | number>({ default: '' });
const { t } = useI18n();

const label = computed(() => feedbackQuestionLabel(props.question, t));
</script>

<template>
  <div class="flex flex-col items-center gap-6">
    <Heading
      size="md"
      as="h3"
      class="text-center max-w-sm"
    >
      {{ label }}
    </Heading>
    <div class="w-full max-w-sm">
      <Input
        v-model="model"
        :aria-label="label"
        :placeholder="$t('unified.common.typeHere')"
        maxlength="300"
      />
    </div>
  </div>
</template>
